function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "/ page"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Go to"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "confirm"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Previous Page"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Next Page"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Previous 5 Pages"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Next 5 Pages"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Previous 3 Pages"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Next 3 Pages"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Select time"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Select date"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "Start date"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "End date"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "Select year"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "Select quarter"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "Select month"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "Select week"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "Start year"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "End year"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "Start month"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "End month"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "Start week"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "End week"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "Today"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "Now"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "Back to today"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "Ok"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "Clear"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "Month"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "Year"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "select time"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "select date"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "Choose a week"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "Choose a month"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "Choose a year"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "Choose a decade"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "Previous month (PageUp)"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "Next month (PageDown)"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "Last year (Control + left)"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "Next year (Control + right)"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "Last decade"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "Next decade"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "Last century"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "Next century"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "Please select"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "Filter menu"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "OK"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "Reset"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "No filters"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "No data"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "Select current page"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "Invert current page"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "Select all data"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "Sort"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "Expand row"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "Collapse row"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "Click to sort by descending"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "Click to sort by ascending"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "Click to cancel sorting"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "OK"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "Cancel"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "OK"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "OK"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "Cancel"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "', '"
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "Search here"
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "item"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "items"
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "Remove"
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        "Select current page"
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "Remove current page"
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "Select all data"
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "Remove all data"
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "Invert current page"
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        "Uploading..."
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "Remove file"
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        "Upload error"
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "Preview file"
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "Download file"
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "No Data"
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "icon"
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "Edit"
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "Copy"
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "Copied"
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "Expand"
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _taggedTemplateLiteral([
        "Back"
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
import React from "react";
import { ConfigProvider as AntConfigProvider } from "antd";
import { t } from "ttag";
function isHTMLElement(node) {
    return (node === null || node === void 0 ? void 0 : node.nodeType) === Node.ELEMENT_NODE;
}
function findParentNodeWithSelector(node, selector) {
    return _instanceof(node, Element) ? node.closest(selector) : null;
}
var AntDTranslationProvider = function(param) {
    var locale = param.locale, children = param.children;
    // source strings are taken from https://github.com/react-component/pagination/blob/master/src/locale/en_US.js
    var Pagination = {
        // Options.jsx
        items_per_page: t(_templateObject()),
        jump_to: t(_templateObject1()),
        jump_to_confirm: t(_templateObject2()),
        // Pagination.jsx
        prev_page: t(_templateObject3()),
        next_page: t(_templateObject4()),
        prev_5: t(_templateObject5()),
        next_5: t(_templateObject6()),
        prev_3: t(_templateObject7()),
        next_3: t(_templateObject8())
    };
    // source string are taken from https://github.com/ant-design/ant-design/blob/3.x-stable/components/time-picker/locale/en_US.tsx
    var TimePicker = {
        placeholder: t(_templateObject9())
    };
    // source strings are taken from https://github.com/ant-design/ant-design/blob/3.x-stable/components/date-picker/locale/en_US.tsx
    // + https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
    // + https://github.com/react-component/calendar/blob/master/src/locale/en_US.js
    var DatePicker = {
        lang: {
            locale: locale,
            placeholder: t(_templateObject10()),
            rangePlaceholder: [
                t(_templateObject11()),
                t(_templateObject12())
            ],
            yearPlaceholder: t(_templateObject13()),
            quarterPlaceholder: t(_templateObject14()),
            monthPlaceholder: t(_templateObject15()),
            weekPlaceholder: t(_templateObject16()),
            rangeYearPlaceholder: [
                t(_templateObject17()),
                t(_templateObject18())
            ],
            rangeMonthPlaceholder: [
                t(_templateObject19()),
                t(_templateObject20())
            ],
            rangeWeekPlaceholder: [
                t(_templateObject21()),
                t(_templateObject22())
            ],
            // taken from https://github.com/react-component/calendar/blob/master/src/locale/en_US.js
            today: t(_templateObject23()),
            now: t(_templateObject24()),
            backToToday: t(_templateObject25()),
            ok: t(_templateObject26()),
            clear: t(_templateObject27()),
            month: t(_templateObject28()),
            year: t(_templateObject29()),
            timeSelect: t(_templateObject30()),
            dateSelect: t(_templateObject31()),
            weekSelect: t(_templateObject32()),
            monthSelect: t(_templateObject33()),
            yearSelect: t(_templateObject34()),
            decadeSelect: t(_templateObject35()),
            yearFormat: "YYYY",
            dateFormat: "M/D/YYYY",
            dayFormat: "D",
            dateTimeFormat: "M/D/YYYY HH:mm:ss",
            monthBeforeYear: true,
            previousMonth: t(_templateObject36()),
            nextMonth: t(_templateObject37()),
            previousYear: t(_templateObject38()),
            nextYear: t(_templateObject39()),
            previousDecade: t(_templateObject40()),
            nextDecade: t(_templateObject41()),
            previousCentury: t(_templateObject42()),
            nextCentury: t(_templateObject43())
        },
        timePickerLocale: _objectSpread({}, TimePicker),
        dateFormat: "YYYY-MM-DD",
        dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
        weekFormat: "YYYY-wo",
        monthFormat: "YYYY-MM"
    };
    return /*#__PURE__*/ React.createElement(AntConfigProvider, {
        locale: {
            // source strings are taken from https://github.com/ant-design/ant-design/blob/3.x-stable/components/locale/default.tsx
            locale: locale,
            global: {
                placeholder: t(_templateObject44())
            },
            Pagination: Pagination,
            // Calendar strings are a copy of date-picker: https://github.com/ant-design/ant-design/blob/3.x-stable/components/calendar/locale/en_US.tsx
            Calendar: DatePicker,
            DatePicker: DatePicker,
            TimePicker: TimePicker,
            Table: {
                filterTitle: t(_templateObject45()),
                filterConfirm: t(_templateObject46()),
                filterReset: t(_templateObject47()),
                filterEmptyText: t(_templateObject48()),
                emptyText: t(_templateObject49()),
                selectAll: t(_templateObject50()),
                selectInvert: t(_templateObject51()),
                selectionAll: t(_templateObject52()),
                sortTitle: t(_templateObject53()),
                expand: t(_templateObject54()),
                collapse: t(_templateObject55()),
                triggerDesc: t(_templateObject56()),
                triggerAsc: t(_templateObject57()),
                cancelSort: t(_templateObject58())
            },
            Modal: {
                okText: t(_templateObject59()),
                cancelText: t(_templateObject60()),
                justOkText: t(_templateObject61())
            },
            Popconfirm: {
                okText: t(_templateObject62()),
                cancelText: t(_templateObject63())
            },
            Transfer: {
                titles: [
                    t(_templateObject64())
                ],
                searchPlaceholder: t(_templateObject65()),
                itemUnit: t(_templateObject66()),
                itemsUnit: t(_templateObject67()),
                remove: t(_templateObject68()),
                selectCurrent: t(_templateObject69()),
                removeCurrent: t(_templateObject70()),
                selectAll: t(_templateObject71()),
                removeAll: t(_templateObject72()),
                selectInvert: t(_templateObject73())
            },
            Upload: {
                uploading: t(_templateObject74()),
                removeFile: t(_templateObject75()),
                uploadError: t(_templateObject76()),
                previewFile: t(_templateObject77()),
                downloadFile: t(_templateObject78())
            },
            Empty: {
                description: t(_templateObject79())
            },
            Icon: {
                icon: t(_templateObject80())
            },
            Text: {
                edit: t(_templateObject81()),
                copy: t(_templateObject82()),
                copied: t(_templateObject83()),
                expand: t(_templateObject84())
            },
            PageHeader: {
                back: t(_templateObject85())
            }
        },
        getPopupContainer: function(node) {
            // Try to render the popup as close to the triggering element as possible, so that the
            // popup/dropdown scrolls with the triggering element.
            // Skip table elements - let them use default container behavior
            var table = findParentNodeWithSelector(node, ".ant-table");
            if (table) {
                return document.body;
            }
            // For Select dropdown, we explicitly do not look for `.ant-select-item-option` because
            // when the dropdown has only one item, the tooltip gets cropped.
            var selectDropdown = findParentNodeWithSelector(node, ".ant-select");
            if (selectDropdown) {
                return selectDropdown;
            }
            var label = findParentNodeWithSelector(node, ".ant-form-item");
            if (label) {
                return label;
            }
            var modal = findParentNodeWithSelector(node, ".ant-modal-content");
            if (modal) {
                return modal;
            }
            if (isHTMLElement(node === null || node === void 0 ? void 0 : node.parentNode)) {
                return node.parentNode;
            }
            return document.body;
        }
    }, children);
};
export default AntDTranslationProvider;
